import { CommonConfig } from '../common-config';
import { Inject, Injectable } from '@angular/core';
import { Meta, MetaDefinition } from '@angular/platform-browser';

@Injectable({
  providedIn: "root",
})
export class MetaService {
  /**
   * The meta tags of the page.
   */
  public defaultMetaTags: MetaDefinition[] = [
    {
      name: "description",
      content: "Share your favorite music gear",
    },
    {
      property: "og:site_name",
      content: "rigshare.com",
    },
    {
      property: "og:url",
      content: "{url}",
    },
    {
      property: "og:type",
      content: "website",
    },
    {
      property: "fb:app_id",
      content: "1780977915322258",
    },
    {
      property: "og:title",
      content: "RigShare",
    },
    {
      property: "og:description",
      content: "Share your favorite music gear",
    },
    {
      property: "og:image",
      content: "{url}/assets/img/social.png",
    },
    {
      name: "twitter:card",
      content: "summary",
    },
    {
      name: "twitter:site",
      content: "@rigshare",
    },
    {
      name: "twitter:title",
      content: "RigShare",
    },
    {
      name: "twitter:description",
      content: "Share your favorite music gear",
    },
    {
      name: "twitter:image",
      content: "{url}/assets/img/social.png",
    },
    {
      // name: 'apple-itunes-app',
      // content: 'app-id=1202707739',
    },
  ];

  /**
   * Create a new instance of the service.
   */
  constructor(
    @Inject("RIGSHARE_COMMON_CONFIG") protected config: CommonConfig,
    private meta: Meta
  ) {}

  /**
   * Create meta tags.
   */
  create(tags: MetaDefinition[] = []): void {
    tags = this.overrideTags(tags);
    tags = this.replaceUrlInMetaTags(tags);
    tags.forEach((tag) => this.meta.updateTag(tag));
  }

  /**
   * Override default tags.
   */
  overrideTags(tags: MetaDefinition[]): MetaDefinition[] {
    const metaTags = [...this.defaultMetaTags];

    tags.forEach((tag) => {
      const index = metaTags.findIndex((m) => {
        const keys = Object.keys(tag);

        return tag[keys[0]] === m[keys[0]];
      });

      if (index >= 0) {
        if (tag.content) {
          metaTags[index] = tag;
        }
      } else {
        metaTags.push(tag);
      }
    });

    return metaTags;
  }

  /**
   * Replace url placeholder in meta tags.
   */
  replaceUrlInMetaTags(metaTags: MetaDefinition[]): MetaDefinition[] {
    return metaTags.map((tag) => {
      if (tag.content) {
        tag.content = tag.content.replace("{url}", this.config.environment.url);
      }

      return tag;
    });
  }
}
